<template>
  <div class="modal fade show" ref="modalError" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-success">
        <div class="modal-body">
          <p class="modal-txt" v-html="modalContent"></p>
        </div>
        <div class="modal-footer pt-0">
          <button type="button" class="btn btn-common w-100" data-dismiss="modal">{{textButtonClose}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modalMixin from './modalMixin';

export default {
  mixins: [modalMixin],
  name: 'ModalSuccess',
  props: {
    idModal: {
      type: String,
      default: 'idModal'
    },
    modalContent: {
      type: String,
      default: ''
    },
    keyTextButtonClose: {
      type: String,
      default: 'common.button.close_modal_error'
    }
  },
  data () {
    return {
      ref: 'modalError'
    }
  },
  computed: {
    textButtonClose () {
      return this.$t(this.keyTextButtonClose);
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/ModalError.vue